import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import { ReactComponent as ExpandPlus } from 'static/assets/ui/plus.svg'
import './TabAccordion.scss'

const TabAccordion = ({ headline, tabs }) => {
  const [value, setValue] = React.useState(0)
  const [expanded, setExpanded] = React.useState(null)

  function handleTabChange(event, tabValue) {
    setValue(tabValue)
  }

  const handlePanelChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <section className="tab-accordion-section section container-fluid pt-7 pt-md-4 pb-9 pb-md-8 px-0">
      <div className="container px-0">
        {
          headline && (
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6 mb-4 text-center text-m">
                <h2>{ headline }</h2>
              </div>
            </div>
          )
        }
        <div className="accordion-wrapper row d-flex flex-column flex-lg-row">
          {
            tabs.length > 0 && (
              <Tabs value={value} onChange={handleTabChange} variant="scrollable" scrollButtons="off" className="accordion-tabs col-lg-4 offset-lg-1 mb-2 mb-lg-0 mr-lg-1 p-lg-0">
                {
                  tabs.map(tab => (
                    <Tab label={tab.title} key={tab.title} className="text-l text-white px-1" />
                  ))
                }
              </Tabs>
            )
          }
          {
            tabs.length > 0 && tabs.map((tab, tabIndex) => (
              <>
                {
                  value === tabIndex && (
                    <div className="accordion-inner bg-white col-lg-6 flex-lg-grow-1 p-lg-0 px-2">
                      {
                        tab.is_accordion && tab.accordion_items.length > 0 && tab.accordion_items.map((item, itemIndex) => (
                          <ExpansionPanel
                            key={item.question}
                            expanded={expanded === `panel${itemIndex}`}
                            onChange={handlePanelChange(`panel${itemIndex}`)}
                            className="accordion-item"
                          >
                            <ExpansionPanelSummary className="panel-summary" expandIcon={<ExpandPlus className="expandIcon" />}>
                              <p>{item.question}</p>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details p-0 pr-lg-1 pb-1 pl-lg-1">
                              <div
                                className="entry color-darkgray"
                                dangerouslySetInnerHTML={{ __html: item.answer }}
                              />
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        ))
                      }
                      {
                        !tab.is_accordion && tab.list_items.length > 0 && tab.list_items.map((item, itemIndex) => (
                          <ExpansionPanel
                            expanded={expanded === `panel${itemIndex}`}
                            className="list-item"
                          >
                            <ExpansionPanelSummary className="panel-summary">
                              <p>{item.item_headline}</p>
                              <div
                                className="entry text-secondary"
                                dangerouslySetInnerHTML={{ __html: item.item_description }}
                              />
                            </ExpansionPanelSummary>
                          </ExpansionPanel>
                        ))
                      }
                    </div>
                  )
                }
              </>
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default TabAccordion
